import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function GranulatorSVG({ value, config = {}, width = 70, height = 80 }) {
    const running = parseFloat(value) >= (parseFloat(config.threshold ?? 0.5));
    const color = running ? (config.run_color || '#22C55E') : (config.stop_color || '#64748B');
    const cx = width / 2;
    const bodyX = 6;
    const bodyY = 6;
    const bodyW = width - 12;
    const bodyH = height * 0.7;
    const screenH = height * 0.08;
    const screenY = bodyY + bodyH;
    const outH = height * 0.15;
    const outY = screenY + screenH;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Body cylinder */}
            <rect x={bodyX} y={bodyY} width={bodyW} height={bodyH} rx={6} fill="#1E293B" stroke={color} strokeWidth={2} />
            {/* Rotor shaft + blades */}
            <line x1={cx} y1={bodyY + 4} x2={cx} y2={bodyY + bodyH - 4} stroke={color} strokeWidth={2} />
            {[0.25, 0.5, 0.75].map((t, i) => {
                const y = bodyY + bodyH * t;
                const blade = bodyW * 0.35;
                return (
                    <g key={i}>
                        <line x1={cx - blade} y1={y - 4} x2={cx + blade} y2={y + 4} stroke={color} strokeWidth={2} strokeLinecap="round" />
                    </g>
                );
            })}
            {/* Screen (perforated bar) */}
            <rect x={bodyX} y={screenY} width={bodyW} height={screenH} rx={2} fill="#334155" stroke={color} strokeWidth={1.5} />
            {[1, 2, 3, 4, 5].map(i => (
                <circle key={i} cx={bodyX + (bodyW / 6) * i} cy={screenY + screenH / 2} r={2} fill="#0F172A" />
            ))}
            {/* Outlet */}
            <polygon points={`${cx - 10},${outY} ${cx + 10},${outY} ${cx + 5},${outY + outH} ${cx - 5},${outY + outH}`} fill="#1E293B" stroke={color} strokeWidth={1.5} />
            {/* Inlet top */}
            <rect x={cx - 8} y={0} width={16} height={bodyY + 4} rx={3} fill="#1E293B" stroke={color} strokeWidth={1.5} />
        </svg>
    );
}

export default function GranulatorNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <GranulatorSVG value={data?.liveValues?.state ?? data?.liveValue} config={data?.config} width={data?.width || 70} height={data?.height || 80} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
